import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ModalViewProperties } from '../modal-view-properties';
import { DirectoryNumberRef, EndUser, EndUserRef, EndUserResult } from '../../shared/models/generated/ziroModels';
import { EndUserResource } from '../../shared/resources/end-user.resource';
import { Observable, Subscription } from 'rxjs';
import { ModalBodyClass } from '../modal-body';
import { ZiroFormConfig } from '../../forms/ziro-forms-models';
import { PromptModalComponent } from '../prompt-modal/prompt-modal.component';
import { ZiroFormStateService } from '../../forms/ziro-form-state.service';
import { ZiroSelectConfig } from '../../forms/fields/select/ziro-select.component';
import { ZiroFormsModule } from '../../forms/ziro-forms.module';

export interface PrimaryExtensionPickerModalViewProperties extends ModalViewProperties {
  user: EndUserResult;
  extensions: DirectoryNumberRef[];
}

export interface PrimaryExtensionPickerModalComponentReturnValue {
  endUserRef: EndUserRef;
  dnRef: DirectoryNumberRef;
}

@Component({
  selector: 'ziro-primary-extension-picker-modal',
  templateUrl: './primary-extension-picker-modal.component.html',
  standalone: true,
  imports: [ZiroFormsModule],
})
export class PrimaryExtensionPickerModalComponent extends ModalBodyClass implements OnDestroy, OnInit {
  private endUserResource = inject(EndUserResource);
  private modalComponent = inject<PromptModalComponent<any>>(PromptModalComponent);
  protected _ziroFormStateService: ZiroFormStateService;

  protected formConfig: ZiroFormConfig;
  modalViewProperties: PrimaryExtensionPickerModalViewProperties;
  selectedExtension: string;

  private _subscriptions = new Subscription();

  ngOnInit(): void {
    const passedExtensions = this.modalComponent.modalViewProperties.extensions;
    const extensions = passedExtensions.map((extension: any) => {
      return extension.extension;
    });
    this.formConfig = {
      fields: {
        primaryExtensionPicker: {
          dataAutomation: 'ziro-select-input',
          componentConfig: new ZiroSelectConfig({
            options: extensions,
            bindValue: 'extension',
            clearWithInput: true,
            hideClear: true,
          }),
          required: true,
        },
      },
      options: {
        columnClasses: {
          label: 'd-none',
          input: 'col-12',
        },
      },
    } as ZiroFormConfig;
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  submit(): Observable<any> {
    this.selectedExtension = this.formData.primaryExtensionPicker;
    return new Observable((subscriber) => {
      this.endUserResource
        .get(
          this.modalComponent.modalViewProperties.user.ref.id,
          this.modalComponent.modalViewProperties.user.ref.serverId,
        )
        .subscribe((endUser: EndUser) => {
          const selectedDnRef = this.modalComponent.modalViewProperties.extensions.find(
            (extension: DirectoryNumberRef) => extension.extension === this.selectedExtension,
          );
          endUser = { ...endUser, primaryExtension: selectedDnRef };
          this.endUserResource
            .put(endUser, this.modalComponent.modalViewProperties.user.ref.serverId)
            .subscribe((endUserRef: EndUserRef) => {
              subscriber.next({
                endUserRef: endUserRef,
                dnRef: selectedDnRef,
              });
              subscriber.complete();
            });
        });
    });
  }
}
